import {
  DASHBOARD_URL,
  UN_AUTHORIZED_URL,
} from './../../../shared/constants/constant';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-unauthorised-access-page',
  templateUrl: './unauthorised-access-page.component.html',
  styleUrls: ['./unauthorised-access-page.component.scss'],
})
export class UnauthorisedAccessPageComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {
    if (this.authService.getUserRoles()) {
      this.router.navigateByUrl(DASHBOARD_URL);
    }
  }

  ngOnInit(): void {}

  redirectToBHP(): void {
    window.location.href = 'https://spo.bhpbilliton.com/sites/dw';
  }
}
